import type { Session } from "@supabase/supabase-js";
import { supabase } from "./supabase.ts";

type Listener = (session: Session | null) => void;
const listeners = new Set<Listener>();

export function onAuthChange(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

supabase.auth.getSession().then(({ data }) => {
  for (const fn of listeners) fn(data.session);
});

supabase.auth.onAuthStateChange((_event, session) => {
  for (const fn of listeners) fn(session);
});

export function mountAuthUI(container: HTMLElement): void {
  const render = (session: Session | null) => {
    container.innerHTML = "";
    if (session?.user) {
      const span = document.createElement("span");
      span.className = "user";
      span.textContent = session.user.email ?? "eingeloggt";
      const btn = document.createElement("button");
      btn.type = "button";
      btn.textContent = "Logout";
      btn.addEventListener("click", () => {
        void supabase.auth.signOut();
      });
      container.append(span, " ", btn);
      return;
    }

    const form = document.createElement("form");
    form.style.display = "flex";
    form.style.gap = "0.35rem";
    const input = document.createElement("input");
    input.type = "email";
    input.placeholder = "E-Mail";
    input.required = true;
    input.autocomplete = "email";
    const btn = document.createElement("button");
    btn.type = "submit";
    btn.textContent = "Login-Link";
    form.append(input, btn);
    form.addEventListener("submit", async (ev) => {
      ev.preventDefault();
      btn.disabled = true;
      const { error } = await supabase.auth.signInWithOtp({
        email: input.value.trim(),
        options: {
          emailRedirectTo: window.location.origin,
          // Keine Selbstregistrierung: Magic-Link nur für bereits angelegte
          // Wehr-Accounts (zusätzlich im Dashboard "Allow new users" deaktivieren).
          shouldCreateUser: false,
        },
      });
      btn.disabled = false;
      if (error) {
        const msg = /signups not allowed/i.test(error.message)
          ? "Für diese E-Mail-Adresse gibt es keinen Zugang. Wende dich an die Gemeindewehrführung."
          : "Login fehlgeschlagen: " + error.message;
        alert(msg);
      } else {
        alert("Magic-Link wurde an " + input.value + " gesendet.");
      }
    });
    container.append(form);
  };

  onAuthChange(render);
  void supabase.auth.getSession().then(({ data }) => render(data.session));
}

export async function currentUser() {
  const { data } = await supabase.auth.getUser();
  return data.user ?? null;
}
